import { rankingItems } from '@/mocks/home';

export default function Ranking() {
  const trendIcon = (trend: string) => {
    if (trend === 'up') return <i className="ri-arrow-up-line text-accent-500 text-sm"></i>;
    if (trend === 'new') return <i className="ri-sparkling-line text-primary-500 text-sm"></i>;
    return <i className="ri-subtract-line text-foreground-500 text-sm"></i>;
  };

  return (
    <section id="ranking" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1024px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">
          人气排行
        </h2>
        <p className="text-sm text-foreground-600 mb-6 md:mb-8">实时更新最受读者欢迎的漫画榜单</p>
        <div className="space-y-3">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-4 bg-background-100 rounded-lg p-3 md:p-4 border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors"
            >
              <div className="w-8 h-8 md:w-9 md:h-9 rounded-full flex items-center justify-center shrink-0">
                {item.rank <= 3 ? (
                  <span className={`text-lg md:text-xl font-heading ${
                    item.rank === 1 ? 'text-primary-500' : item.rank === 2 ? 'text-accent-500' : 'text-secondary-500'
                  }`}>
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm font-semibold text-foreground-500">{item.rank}</span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  {trendIcon(item.trend)}
                </div>
                <p className="text-xs text-foreground-600 mt-0.5 line-clamp-1">{item.desc}</p>
              </div>
              <div className="flex items-center gap-1.5 shrink-0">
                <span className="text-xs text-foreground-500">{item.type}</span>
                <span className="px-1.5 py-0.5 text-xs font-semibold rounded bg-primary-100 text-primary-700 whitespace-nowrap">
                  {item.heat}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}